import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import numberArrayGenerator from 'number-array-generator';
import { changeConfigDataValue, changeGenderValue, getReachEstimate } from 'redux/modules/audience';
import * as _ from 'lodash';
import MenuItem from 'material-ui/MenuItem';
import SelectField from 'material-ui/SelectField';
import * as styles from './Audiences.scss';
var AudienceAgeGender = (_dec = connect(function (state) {
  return {
    audience: state.audience,
    targetingConfigData: state.audience.FacebookTargetingConfig.data,
    organization: state.organization.current,
    theme: state.theme
  };
}, {
  changeConfigDataValue: changeConfigDataValue,
  changeGenderValue: changeGenderValue,
  getReachEstimate: getReachEstimate
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(AudienceAgeGender, _Component);

  var _super = _createSuper(AudienceAgeGender);

  function AudienceAgeGender() {
    var _this;

    _classCallCheck(this, AudienceAgeGender);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "renderAgeOptions", function () {
      var startAge = _this.props.type === 'leadGeneration' ? 21 : 13;
      return numberArrayGenerator(startAge, 65).map(function (age) {
        return /*#__PURE__*/React.createElement(MenuItem, {
          value: age,
          key: age,
          primaryText: age
        });
      });
    });

    return _this;
  }

  _createClass(AudienceAgeGender, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var genderValue = 'Everyone';

      if (this.props.targetingConfigData.genders.length < 2) {
        genderValue = this.props.targetingConfigData.genders[0] === 1 ? 'Men' : 'Women';
      }

      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xs-5"
      }, /*#__PURE__*/React.createElement(SelectField, {
        value: genderValue,
        style: {
          top: 10,
          width: '100%'
        },
        onChange: function onChange(e, i, val) {
          _this2.props.changeGenderValue(val);
        }
      }, /*#__PURE__*/React.createElement(MenuItem, {
        value: 'Everyone',
        primaryText: 'Everyone'
      }), /*#__PURE__*/React.createElement(MenuItem, {
        value: 'Men',
        primaryText: 'Men'
      }), /*#__PURE__*/React.createElement(MenuItem, {
        value: 'Women',
        primaryText: 'Women'
      }))), /*#__PURE__*/React.createElement("div", {
        className: "col-xs-3"
      }, /*#__PURE__*/React.createElement(SelectField, {
        value: this.props.targetingConfigData.age_min,
        style: {
          top: 10,
          width: '100%'
        },
        onChange: function onChange(e, i, val) {
          if (parseInt(_this2.props.targetingConfigData.age_max) > parseInt(val) || isNaN(parseInt(_this2.props.targetingConfigData.age_max))) {
            _this2.props.changeConfigDataValue('age_min', val);
          } else {
            alert('Minimum age must be less than the maximum age');
          }
        }
      }, this.renderAgeOptions())), /*#__PURE__*/React.createElement("div", {
        className: "col-xs-1 ",
        style: {
          color: this.props.theme.colors.gray2,
          fontFamily: 'oswald',
          fontSize: 13,
          position: 'relative',
          textAlign: 'center',
          top: 26
        }
      }, "TO"), /*#__PURE__*/React.createElement("div", {
        className: "col-xs-3"
      }, /*#__PURE__*/React.createElement(SelectField, {
        value: this.props.targetingConfigData.age_max,
        style: {
          top: 10,
          width: '100%'
        },
        onChange: function onChange(e, i, val) {
          if (parseInt(_this2.props.targetingConfigData.age_min) < parseInt(val) || isNaN(parseInt(_this2.props.targetingConfigData.age_min))) {
            _this2.props.changeConfigDataValue('age_max', val);
          } else {
            alert('Maximum age must be greater than the minimum age');
          }
        }
      }, this.renderAgeOptions()))));
    }
  }]);

  return AudienceAgeGender;
}(Component)) || _class);
export { AudienceAgeGender as default };